import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icon-file-arrow-down.svg'
import _imports_1 from '@/assets/images/icon-file-arrow-up.svg'
import _imports_2 from '@/assets/images/icon-eye.svg'


const _hoisted_1 = { class: "flex flex-row justify-between gap-2 px-[0.2em] w-full" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full h-6 lg:h-4"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-full h-6 lg:h-4"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-full h-6 lg:h-4"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]


import { contractOptions } from "@/services/movements/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractButonGroup',
  props: {
  movementId: {
    type: Number,
    required: true,
  },
  isContractSigned: {
    type: Boolean,
  },
},
  emits: ["buttonAction"],
  setup(__props, { emit }) {

const props = __props;





function selectionHandler(option: contractOptions) {
  emit("buttonAction", option, props.movementId);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      title: _unref(contractOptions).generate,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectionHandler(_unref(contractOptions).generate)))
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("span", {
      title: _unref(contractOptions).upload,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (selectionHandler(_unref(contractOptions).upload)))
    }, _hoisted_7, 8, _hoisted_5),
    _createElementVNode("span", {
      title: _unref(contractOptions).signed,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (selectionHandler(_unref(contractOptions).signed))),
      class: _normalizeClass(__props.isContractSigned ? '' : 'opacity-25 pointer-events-none')
    }, _hoisted_10, 10, _hoisted_8)
  ]))
}
}

})